import React from 'react';
import { Box, VStack, Text, Image, Link } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { ContentPortfolioDto } from '../../../services/api/contentPortfolio';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface PortfolioContentViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: ContentPortfolioDto | null;
}

const PortfolioContentViewModal: React.FC<PortfolioContentViewModalProps> = ({
  isOpen,
  onClose,
  content,
}) => {
  if (!content) return null;

  return (
    <ModalShell isOpen={isOpen} onClose={onClose} size="xl">
      <VStack spacing={0} align="stretch">
        <Box
          bg={ff.ink}
          maxH="70vh"
          borderRadius="20px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          overflow="hidden"
        >
          {content.contentType === 'video' ? (
            <video
              src={content.downloadUrl}
              controls
              autoPlay
              style={{
                width: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
              }}
            />
          ) : (
            <Image src={content.downloadUrl} alt={content.brand} objectFit="contain" maxH="70vh" w="100%" />
          )}
        </Box>

        <VStack spacing={2} align="stretch" pt={4}>
          <Text as="h2" textStyle="display" fontSize="24px" color={ff.ink}>
            {content.brand}
          </Text>

          {content.postLink && (
            <Link
              href={content.postLink}
              isExternal
              color={ff.ink}
              fontWeight={600}
              textDecoration="underline"
              fontSize="14px"
              display="flex"
              alignItems="center"
              gap={2}
              minH="44px"
            >
              View original post
              <ExternalLinkIcon />
            </Link>
          )}

          <Text fontSize="13px" color={ff.text2}>
            Added {new Date(content.createdAt).toLocaleDateString()}
          </Text>
        </VStack>
      </VStack>
    </ModalShell>
  );
};

export default PortfolioContentViewModal;
